import { Component, Input, OnInit } from "@angular/core";
import { DataService_BusTrackerMap } from "../../../shared/data.service";

@Component({
	selector: "caass-school-bus-alert-bus-table",
	templateUrl: "./school-bus-alert-bus-table.component.html",
	styleUrls: ["./school-bus-alert-bus-table.component.css"],
})
export class SchoolBusAlertBusTableComponent implements OnInit {
	constructor(private BusResultsService: DataService_BusTrackerMap) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadBus();
	}

	ngOnChanges() {
		this.loadBus();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() lstSelectedFromMain: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedBuses: any = [];
	lstBus: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "BusNbr", header: "Bus Number" },
		{ field: "BusDesc", header: "Description" },
		{ field: "AlertDesc", header: "Alert" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadBus() {
		if (this.lstSelectedFromMain == undefined) {
			return;
		}

		this.loading = true;

		var result = this.BusResultsService.BusSelectAll();
		result.subscribe(
			(response) => {
				this.lstBus = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstBus.map((item: any) => item.ActiveDesc)));

				for (var z = 0; z < this.lstBus.length; z++) {
					var next = this.lstBus[z];

					for (var x = 0; x < this.lstSelectedFromMain.length; x++) {
						var fromMain = this.lstSelectedFromMain[x];

						if (next.BusID == fromMain.BusID) {
							this.SelectedBuses = [...this.SelectedBuses, next];
						}
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadBus();
	}

	//Custom Button Methods

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		// this.SelectedBus = val.data;
	}
	onRowUnselect(val) {
		// this.SelectedBus = null;
	}
	onRowDblClick(Bus) {
		// this.SelectedBus = Bus;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	GetSelectedLength() {
		var lst = Array.from(new Set(this.SelectedBuses.map((item: any) => item.BusID)));

		return lst.length;
	}

	////////////////////////////////////////////
}
